<template>
  <van-progress stroke-width="4" v-if="progress" :show-pivot="false" :percentage="progress" color="#996eff" />
</template>

<script>
export default {
  props: {
    progress: {
      type: [String, Number]
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
